<template>
  <div class="page-about-m"  @click.stop="closeShade">
    <Header-m></Header-m>

    <div class="about-banner"></div>
    <div class="about-company"></div>
    <div class="about-company-2"></div>
    <div class="about-company-3"></div>
    <div class="about-dev-history">
      <div class="history-head"></div>
      <div class="history-body-wrap ui-flex ui-flex-justify-center">
        <div class="history-body ui-flex">
          <swiper ref="mySwiper" :options="swiperOptionsm" >
            <swiper-slide v-for="(value) in columns" :key="value.id">
              <div class="body-column" >
                <div class="column-title">{{value.title}}</div>
                
                <ul class="column-list">
                  <li class="list-li" v-for="(v) in value.children" :key="v.id">
                    <strong class="list-li-month">{{v.month}}</strong>
                    <span class="list-li-explain">{{v.explain}}</span>
                  </li>
                </ul>
              </div>
            </swiper-slide>
            
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          
        </div>

      </div>
    </div>

    <Menu  path="/about_m" ref="closeShade"></Menu>
  </div>

</template>
<script>
  import HeaderM from '@/components/wap/HeaderM/index.vue'
   import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import Menu from '@/components/wap/Menu/index.vue'
  import router from '@/router'
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    components: {
      Swiper,
      SwiperSlide,
      Header,
      Footer,
      HeaderM,
      Menu,
    },
    directives: {
      swiper: directive
    },
    data() {
      return {
        swiperOptionsm: {
          autoplay:false,
          autoplayStopOnLast:false,
          slidesPerView: 2,
          slidesPerGroup: 2,
          pagination: {
            el: '.swiper-pagination'
          },
        
        },
        columns:[
          {id:0,title:'2020',children:[
            {id:0,month:'1月',explain:'公司取得“ISO三体系管理认证证书”。'},
          ]},
          {id:1,title:'2019',children:[
            {id:0,month:'12月',explain:'“渝神缘”物联网膜式燃气表正式取得型式批准证书。'},
            {id:1,month:'11月',explain:'公司获得国家“高新技术企业”'},
            {id:2,month:'6月',explain:'“智能燃气管理平台2.0“正式上线'},
            {id:3,month:'5月',explain:'公司各产品均取得“防爆合格证”'},
            {id:4,month:'1月',explain:'“渝神缘”物联网膜式燃气表销量突破十万只'},
          ]},
          {id:2,title:'2018',children:[
            {id:0,month:'12月',explain:'公司取得“基于霍尔开关传感器的天然气表”专利技术'},
            {id:1,month:'1月',explain:'“渝神缘”物联网膜式燃气表销量突破3万只'},

          ]},
          {id:3,title:'2017',children:[
            {id:0,month:'12月',explain:'第一只物联网膜式燃气表研发成功'},
            {id:1,month:'1月',explain:'“智能燃气管理平台1.0”正式上线'},

          ]},
          {id:4,title:'2016',children:[
            {id:0,month:'7月',explain:'“重庆神缘智能科技有限公司”正式成立。'},

          ]},
        ]
      }
    },
    beforeCreate(){
      require('../../../static/js/adaptation.js')
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    methods:{
      closeShade(){
        this.$refs.closeShade.closeShade();
      },
    },
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>